exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".profile-container{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.profile-container img{margin-right:15px}.profile-container .profile-text{display:inline-block}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/pages/Account/InvitationNew/style.scss
// module id = 1451
// module chunks = 0